/**
 * Shared visual tokens for the Member Desk.
 * Aesthetic: CIA analyst workstation × historical archive room.
 */
export const desk = {
  bg:         "#08070A",       // deep desk
  surface:    "#0F0E12",       // panel
  surfaceHi:  "#15131A",       // hover
  ink:        "#E4DFD3",       // primary text
  inkDim:     "#A39E93",       // labels
  inkMuted:   "#6F6A60",       // tertiary
  edge:       "#2D2A26",       // border
  edgeHi:     "#454038",       // hover border
  redact:     "#D92D20",       // accent (existing brand red)
  gold:       "#E0A526",       // founding gold
  classified: "#9FA8D4",       // declassified ink
  go:         "#5DD4B3",       // success
  scanline:   "rgba(255,255,255,0.02)",
};

export const fontMono = "font-mono text-[10px] uppercase tracking-[0.3em]";
export const fontMicro = "font-mono text-[9px] uppercase tracking-[0.3em]";
